import apiClient from './apiClient';

export const getLoginHistory = async ({ userId, limit = 100 } = {}) => {
    try {
        const params = new URLSearchParams({ action: 'list', limit: String(limit) });
        if (userId) {
            params.set('user_id', String(userId));
        }
        const response = await apiClient.get(`/login_history.php?${params.toString()}`);
        return response.data;
    } catch {
        throw new Error('Impossibile caricare lo storico accessi.');
    }
};

export const getSuspiciousAttempts = async ({ limit = 100 } = {}) => {
    try {
        const params = new URLSearchParams({ action: 'list_suspicious', limit: String(limit) });
        const response = await apiClient.get(`/login_history.php?${params.toString()}`);
        return response.data;
    } catch {
        throw new Error('Impossibile caricare i tentativi sospetti.');
    }
};
